export const MAX_LENGTH_TITLE = 100;
export const MAX_LENGTH_OVERVIEW = 500;